// extracted by mini-css-extract-plugin
module.exports = {"icon":"CartIcon_icon__S1T9S"};